export default {
  TEXT: "TEXT",
  RADIO: "RADIO",
  SELECT: "SELECT",
  SWITCH: "SWITCH"
}
